<div class="row social_media_name_container" style="margin: 0px;padding: 0px 15px 15px 15px;">
  <div class="header_account">Manage Your Social Media Connections<button class="close_button"
      (click)="closeDialog()">x</button></div>

  <div class="col-md-4 social_chanel_name_card" *ngFor="let channel of socialChannels">
    <div class="social_chanel_name_card_details mat-elevation-z4">
      <div class="social_chanel_image">
        <img [src]="channel.imgSrc" style="height: 45px;width: 45px;" [alt]="channel.name" />
      </div>
      <div class="social_chanel_name">{{channel.name}}</div>
      <div class="social_chanel_name_content">Connect your {{channel.name}} account</div>
      <div>
        <!-- Button to open the dialog box with channel details -->
        <button class="social_chanel_button" (click)="openContentDialogBox(channel)">Connect</button>
      </div>
      <div style="padding-bottom: 15px;">
        <a class="more_link" [href]="channel.learnMoreLink">Learn More</a>
      </div>
    </div>
  </div>
</div>